
export const meterParameterOptions_v2 = [    
  {
    name: 'dPF',
    displayname:'dPF',
    description: 'Displacement Power Factor (Element)',    
    by:'Elm',
    type:'instantaneous',
    disabled:true,
    uom:'dPF',
    elementOptions: 
      [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]
    
  },
  {
    name: 'dPF',
    displayname:'dPF',
    description: 'Displacement Power Factor (Channel)',    
    by:'Ch',
    type:'instantaneous',
    uom:'dPF',
    disabled:true,
    elementOptions: 
      [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      }
      ,
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [
      {
        name: 'Ch 1',        
        value: '1'
      },
      {
        name: 'Ch 2',        
        value: '2'
      },
      {
        name: 'Ch 3',        
        value: '3'
      },

    ],otherOptions:[]
    
  },
  {
    name: 'DemandkW',
    displayname: 'kW Demand Wattage',
    description: 'Demand Wattage', 
    by:'Elm',
    type:'instantaneous',
    uom:'kW',
    disabled:true,
    elementOptions: 
      [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]
  },
  {
    name: 'DemandkWPeak',
    displayname:'kW Demand Max',
    description: 'Maximum Demand Wattage',
    by:'Elm', 
    type:'accumulator',
    uom:'kW',
    disabled:true,
    elementOptions: 
      [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],
    otherOptions:[]
  },
  {
    name: 'V',
    displayname:'Voltage',
    description: 'Volts',
    by:'Ch',
    type:'instantaneous',
    uom:'Volts',
    disabled:true,
    elementOptions: [],
    channelOptions: [],
    otherOptions: [
      {
        name: 'V1 L1-N',        
        value: 'Vin1L1N',
        enabledFor: [3,12,24,48]
      },        
      {
        name: 'V1 L2-N',        
        value: 'Vin1L2N',
        enabledFor: [3,12,24,48]
        
      },
      {
        name: 'V1 L3-N',        
        value: 'Vin1L3N',
        enabledFor: [3,12,24,48]
      },  
      {
        name: 'V2 L1-N',        
        value: 'Vin2L1N',
        enabledFor: [24,48]
      },        
      {
        name: 'V2 L2-N',        
        value: 'Vin2L2N',
        enabledFor: [24,48]
      },
      {
        name: 'V2 L3-N',        
        value: 'Vin2L3N',
        enabledFor: [24,48]
      },
    ]
  },
  {
    name: 'A',
    displayname:'Current',
    description: 'Current', 
    by:'Ch',
    type:'instantaneous',
    uom:'Amps',
    disabled:true,
    elementOptions: [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [
      {
        name: 'Ch 1',        
        value: '1'
      },
      {
        name: 'Ch 2',        
        value: '2'
      },
      {
        name: 'Ch 3',        
        value: '3'
      },

    ],otherOptions:[]

  },
  {
    name: 'kVAHNet',
    displayname:'kVAh Net',
    description: 'kVAh Net', 
    by:'Elm',
    type:'accumulator',
    uom:'kVAh',
    disabled:true,
    elementOptions: [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]   
  },
  {
    name: 'kVARHNet',
    displayname:'kVARh Net',
    description: 'kVAR Hour Net',
    by:'Elm', 
    type:'accumulator',
    uom:'kVARh',
    disabled:true,
    elementOptions: [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]    
  },
  {
    name: 'kWHNet',
    displayname:'kWh',
    description: 'Watt-Hour',  
    by:'Elm',
    type:'accumulator',
    uom:'kWh',
    disabled:true,
    elementOptions: [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]   
  },
];

export const meterParameterOptions_VM = [    
  {
    name: 'dPF',
    displayname:'dPF',
    description: 'Displacement Power Factor (Virtual Meter)',    
    by:'Elm',
    type:'instantaneous',
    disabled:true,
    uom:'dPF',
    elementOptions: 
      [
      {
        name: 'Virtual Meter 1',        
        value: '1'
      },
      {
          name: 'Virtual Meter 2',  
          value: '2'         
      },
      {
          name: 'Virtual Meter 3',    
          value: '3'     
      },
      {
          name: 'Virtual Meter 4',  
          value: '4'       
      },
      {
        name: 'Virtual Meter 5',  
        value: '5'       
      },
      {
        name: 'Virtual Meter 6',  
        value: '6'       
      },
      {
        name: 'Virtual Meter 7',  
        value: '7'       
      },
      {
        name: 'Virtual Meter 8',  
        value: '8'       
      },
      {
        name: 'Virtual Meter 9',  
        value: '9'       
      },
      {
        name: 'Virtual Meter 10',  
        value: '10'       
      },
      {
        name: 'Virtual Meter 11',  
        value: '11'       
      },
      {
        name: 'Virtual Meter 12',  
        value: '12'       
      },
      {
        name: 'Virtual Meter 13',  
        value: '13'       
      },
      {
        name: 'Virtual Meter 14',  
        value: '14'       
      },
      {
        name: 'Virtual Meter 15',  
        value: '15'       
      },
      {
        name: 'Virtual Meter 16',  
        value: '16'       
      },
	  {
        name: 'Virtual Meter 17',  
        value: '17'       
      },
	  {
        name: 'Virtual Meter 18',  
        value: '18'       
      },
	  {
        name: 'Virtual Meter 19',  
        value: '19'       
      },
	  {
        name: 'Virtual Meter 20',  
        value: '20'       
      },
	  {
        name: 'Virtual Meter 21',  
        value: '21'       
      },
	  {
        name: 'Virtual Meter 22',  
        value: '22'       
      },
	  {
        name: 'Virtual Meter 23',  
        value: '23'       
      },
	  {
        name: 'Virtual Meter 24',  
        value: '24'       
      },
	  {
        name: 'Virtual Meter 25',  
        value: '25'       
      },
	  {
        name: 'Virtual Meter 26',  
        value: '26'       
      },
	  {
        name: 'Virtual Meter 27',  
        value: '27'       
      },
	  {
        name: 'Virtual Meter 28',  
        value: '28'       
      },
	  {
        name: 'Virtual Meter 29',  
        value: '29'       
      },
	  {
        name: 'Virtual Meter 30',  
        value: '30'       
      },
	  {
        name: 'Virtual Meter 31',  
        value: '31'       
      },
	  {
        name: 'Virtual Meter 32',  
        value: '32'       
      },
	  {
        name: 'Virtual Meter 33',  
        value: '33'       
      },
	  {
        name: 'Virtual Meter 34',  
        value: '34'       
      },
	  {
        name: 'Virtual Meter 35',  
        value: '35'       
      },
	  {
        name: 'Virtual Meter 36',  
        value: '36'       
      },
	  {
        name: 'Virtual Meter 37',  
        value: '37'       
      },
	  {
        name: 'Virtual Meter 38',  
        value: '38'       
      },
	  {
        name: 'Virtual Meter 39',  
        value: '39'       
      },
	  {
        name: 'Virtual Meter 40',  
        value: '40'       
      },
	  {
        name: 'Virtual Meter 41',  
        value: '41'       
      },
	  {
        name: 'Virtual Meter 42',  
        value: '42'       
      },
	  {
        name: 'Virtual Meter 43',  
        value: '43'       
      },
	  {
        name: 'Virtual Meter 44',  
        value: '44'       
      },
	  {
        name: 'Virtual Meter 45',  
        value: '45'       
      },
	  {
        name: 'Virtual Meter 46',  
        value: '46'       
      },
	  {
        name: 'Virtual Meter 47',  
        value: '47'       
      },
	  {
        name: 'Virtual Meter 48',  
        value: '48'       
      },
    ],
    channelOptions: [],otherOptions:[]
    
  },
  {
    name: 'dPF',
    displayname:'dPF',
    description: 'Displacement Power Factor (Channel)',    
    by:'Ch',
    type:'instantaneous',
    uom:'dPF',
    disabled:true,
    elementOptions: 
    [
      {
        name: 'Virtual Meter 1',        
        value: '1'
      },
      {
          name: 'Virtual Meter 2',  
          value: '2'         
      },
      {
          name: 'Virtual Meter 3',    
          value: '3'     
      },
      {
          name: 'Virtual Meter 4',  
          value: '4'       
      },
      {
        name: 'Virtual Meter 5',  
        value: '5'       
      },
      {
        name: 'Virtual Meter 6',  
        value: '6'       
      },
      {
        name: 'Virtual Meter 7',  
        value: '7'       
      },
      {
        name: 'Virtual Meter 8',  
        value: '8'       
      },
      {
        name: 'Virtual Meter 9',  
        value: '9'       
      },
      {
        name: 'Virtual Meter 10',  
        value: '10'       
      },
      {
        name: 'Virtual Meter 11',  
        value: '11'       
      },
      {
        name: 'Virtual Meter 12',  
        value: '12'       
      },
      {
        name: 'Virtual Meter 13',  
        value: '13'       
      },
      {
        name: 'Virtual Meter 14',  
        value: '14'       
      },
      {
        name: 'Virtual Meter 15',  
        value: '15'       
      },
      {
        name: 'Virtual Meter 16',  
        value: '16'       
      },
	  {
        name: 'Virtual Meter 17',  
        value: '17'       
      },
	  {
        name: 'Virtual Meter 18',  
        value: '18'       
      },
	  {
        name: 'Virtual Meter 19',  
        value: '19'       
      },
	  {
        name: 'Virtual Meter 20',  
        value: '20'       
      },
	  {
        name: 'Virtual Meter 21',  
        value: '21'       
      },
	  {
        name: 'Virtual Meter 22',  
        value: '22'       
      },
	  {
        name: 'Virtual Meter 23',  
        value: '23'       
      },
	  {
        name: 'Virtual Meter 24',  
        value: '24'       
      },
	  {
        name: 'Virtual Meter 25',  
        value: '25'       
      },
	  {
        name: 'Virtual Meter 26',  
        value: '26'       
      },
	  {
        name: 'Virtual Meter 27',  
        value: '27'       
      },
	  {
        name: 'Virtual Meter 28',  
        value: '28'       
      },
	  {
        name: 'Virtual Meter 29',  
        value: '29'       
      },
	  {
        name: 'Virtual Meter 30',  
        value: '30'       
      },
	  {
        name: 'Virtual Meter 31',  
        value: '31'       
      },
	  {
        name: 'Virtual Meter 32',  
        value: '32'       
      },
	  {
        name: 'Virtual Meter 33',  
        value: '33'       
      },
	  {
        name: 'Virtual Meter 34',  
        value: '34'       
      },
	  {
        name: 'Virtual Meter 35',  
        value: '35'       
      },
	  {
        name: 'Virtual Meter 36',  
        value: '36'       
      },
	  {
        name: 'Virtual Meter 37',  
        value: '37'       
      },
	  {
        name: 'Virtual Meter 38',  
        value: '38'       
      },
	  {
        name: 'Virtual Meter 39',  
        value: '39'       
      },
	  {
        name: 'Virtual Meter 40',  
        value: '40'       
      },
	  {
        name: 'Virtual Meter 41',  
        value: '41'       
      },
	  {
        name: 'Virtual Meter 42',  
        value: '42'       
      },
	  {
        name: 'Virtual Meter 43',  
        value: '43'       
      },
	  {
        name: 'Virtual Meter 44',  
        value: '44'       
      },
	  {
        name: 'Virtual Meter 45',  
        value: '45'       
      },
	  {
        name: 'Virtual Meter 46',  
        value: '46'       
      },
	  {
        name: 'Virtual Meter 47',  
        value: '47'       
      },
	  {
        name: 'Virtual Meter 48',  
        value: '48'       
      },
    ],
	channelOptions: [
      {
        name: 'Ch 1',        
        value: '1'
      },
      {
        name: 'Ch 2',        
        value: '2'
      },
      {
        name: 'Ch 3',        
        value: '3'
      },

    ],otherOptions:[]
    
  },
  {
    name: 'DemandkW',
    displayname: 'kW Demand Wattage',
    description: 'Demand Wattage', 
    by:'Elm',
    type:'instantaneous',
    uom:'kW',
    disabled:true,
    elementOptions: 
    [
      {
        name: 'Virtual Meter 1',        
        value: '1'
      },
      {
          name: 'Virtual Meter 2',  
          value: '2'         
      },
      {
          name: 'Virtual Meter 3',    
          value: '3'     
      },
      {
          name: 'Virtual Meter 4',  
          value: '4'       
      },
      {
        name: 'Virtual Meter 5',  
        value: '5'       
      },
      {
        name: 'Virtual Meter 6',  
        value: '6'       
      },
      {
        name: 'Virtual Meter 7',  
        value: '7'       
      },
      {
        name: 'Virtual Meter 8',  
        value: '8'       
      },
      {
        name: 'Virtual Meter 9',  
        value: '9'       
      },
      {
        name: 'Virtual Meter 10',  
        value: '10'       
      },
      {
        name: 'Virtual Meter 11',  
        value: '11'       
      },
      {
        name: 'Virtual Meter 12',  
        value: '12'       
      },
      {
        name: 'Virtual Meter 13',  
        value: '13'       
      },
      {
        name: 'Virtual Meter 14',  
        value: '14'       
      },
      {
        name: 'Virtual Meter 15',  
        value: '15'       
      },
      {
        name: 'Virtual Meter 16',  
        value: '16'       
      },
	  {
        name: 'Virtual Meter 17',  
        value: '17'       
      },
	  {
        name: 'Virtual Meter 18',  
        value: '18'       
      },
	  {
        name: 'Virtual Meter 19',  
        value: '19'       
      },
	  {
        name: 'Virtual Meter 20',  
        value: '20'       
      },
	  {
        name: 'Virtual Meter 21',  
        value: '21'       
      },
	  {
        name: 'Virtual Meter 22',  
        value: '22'       
      },
	  {
        name: 'Virtual Meter 23',  
        value: '23'       
      },
	  {
        name: 'Virtual Meter 24',  
        value: '24'       
      },
	  {
        name: 'Virtual Meter 25',  
        value: '25'       
      },
	  {
        name: 'Virtual Meter 26',  
        value: '26'       
      },
	  {
        name: 'Virtual Meter 27',  
        value: '27'       
      },
	  {
        name: 'Virtual Meter 28',  
        value: '28'       
      },
	  {
        name: 'Virtual Meter 29',  
        value: '29'       
      },
	  {
        name: 'Virtual Meter 30',  
        value: '30'       
      },
	  {
        name: 'Virtual Meter 31',  
        value: '31'       
      },
	  {
        name: 'Virtual Meter 32',  
        value: '32'       
      },
	  {
        name: 'Virtual Meter 33',  
        value: '33'       
      },
	  {
        name: 'Virtual Meter 34',  
        value: '34'       
      },
	  {
        name: 'Virtual Meter 35',  
        value: '35'       
      },
	  {
        name: 'Virtual Meter 36',  
        value: '36'       
      },
	  {
        name: 'Virtual Meter 37',  
        value: '37'       
      },
	  {
        name: 'Virtual Meter 38',  
        value: '38'       
      },
	  {
        name: 'Virtual Meter 39',  
        value: '39'       
      },
	  {
        name: 'Virtual Meter 40',  
        value: '40'       
      },
	  {
        name: 'Virtual Meter 41',  
        value: '41'       
      },
	  {
        name: 'Virtual Meter 42',  
        value: '42'       
      },
	  {
        name: 'Virtual Meter 43',  
        value: '43'       
      },
	  {
        name: 'Virtual Meter 44',  
        value: '44'       
      },
	  {
        name: 'Virtual Meter 45',  
        value: '45'       
      },
	  {
        name: 'Virtual Meter 46',  
        value: '46'       
      },
	  {
        name: 'Virtual Meter 47',  
        value: '47'       
      },
	  {
        name: 'Virtual Meter 48',  
        value: '48'       
      },
    ],
	channelOptions: [],otherOptions:[]
  },
  {
    name: 'DemandkWPeak',
    displayname:'kW Demand Max',
    description: 'Maximum Demand Wattage',
    by:'Elm', 
    type:'accumulator',
    uom:'kW',
    disabled:true,
    elementOptions: 
    [
      {
        name: 'Virtual Meter 1',        
        value: '1'
      },
      {
          name: 'Virtual Meter 2',  
          value: '2'         
      },
      {
          name: 'Virtual Meter 3',    
          value: '3'     
      },
      {
          name: 'Virtual Meter 4',  
          value: '4'       
      },
      {
        name: 'Virtual Meter 5',  
        value: '5'       
      },
      {
        name: 'Virtual Meter 6',  
        value: '6'       
      },
      {
        name: 'Virtual Meter 7',  
        value: '7'       
      },
      {
        name: 'Virtual Meter 8',  
        value: '8'       
      },
      {
        name: 'Virtual Meter 9',  
        value: '9'       
      },
      {
        name: 'Virtual Meter 10',  
        value: '10'       
      },
      {
        name: 'Virtual Meter 11',  
        value: '11'       
      },
      {
        name: 'Virtual Meter 12',  
        value: '12'       
      },
      {
        name: 'Virtual Meter 13',  
        value: '13'       
      },
      {
        name: 'Virtual Meter 14',  
        value: '14'       
      },
      {
        name: 'Virtual Meter 15',  
        value: '15'       
      },
      {
        name: 'Virtual Meter 16',  
        value: '16'       
      },
	  {
        name: 'Virtual Meter 17',  
        value: '17'       
      },
	  {
        name: 'Virtual Meter 18',  
        value: '18'       
      },
	  {
        name: 'Virtual Meter 19',  
        value: '19'       
      },
	  {
        name: 'Virtual Meter 20',  
        value: '20'       
      },
	  {
        name: 'Virtual Meter 21',  
        value: '21'       
      },
	  {
        name: 'Virtual Meter 22',  
        value: '22'       
      },
	  {
        name: 'Virtual Meter 23',  
        value: '23'       
      },
	  {
        name: 'Virtual Meter 24',  
        value: '24'       
      },
	  {
        name: 'Virtual Meter 25',  
        value: '25'       
      },
	  {
        name: 'Virtual Meter 26',  
        value: '26'       
      },
	  {
        name: 'Virtual Meter 27',  
        value: '27'       
      },
	  {
        name: 'Virtual Meter 28',  
        value: '28'       
      },
	  {
        name: 'Virtual Meter 29',  
        value: '29'       
      },
	  {
        name: 'Virtual Meter 30',  
        value: '30'       
      },
	  {
        name: 'Virtual Meter 31',  
        value: '31'       
      },
	  {
        name: 'Virtual Meter 32',  
        value: '32'       
      },
	  {
        name: 'Virtual Meter 33',  
        value: '33'       
      },
	  {
        name: 'Virtual Meter 34',  
        value: '34'       
      },
	  {
        name: 'Virtual Meter 35',  
        value: '35'       
      },
	  {
        name: 'Virtual Meter 36',  
        value: '36'       
      },
	  {
        name: 'Virtual Meter 37',  
        value: '37'       
      },
	  {
        name: 'Virtual Meter 38',  
        value: '38'       
      },
	  {
        name: 'Virtual Meter 39',  
        value: '39'       
      },
	  {
        name: 'Virtual Meter 40',  
        value: '40'       
      },
	  {
        name: 'Virtual Meter 41',  
        value: '41'       
      },
	  {
        name: 'Virtual Meter 42',  
        value: '42'       
      },
	  {
        name: 'Virtual Meter 43',  
        value: '43'       
      },
	  {
        name: 'Virtual Meter 44',  
        value: '44'       
      },
	  {
        name: 'Virtual Meter 45',  
        value: '45'       
      },
	  {
        name: 'Virtual Meter 46',  
        value: '46'       
      },
	  {
        name: 'Virtual Meter 47',  
        value: '47'       
      },
	  {
        name: 'Virtual Meter 48',  
        value: '48'       
      },
    ],
	  channelOptions: [],
    otherOptions:[]
  },
  {
    name: 'V',
    displayname:'Voltage',
    description: 'Volts',
    by:'Ch',
    type:'instantaneous',
    uom:'Volts',
    disabled:true,
    elementOptions: [],
    channelOptions: [],
    otherOptions: [
      {
        name: 'V1 L1-N',        
        value: 'Vin1L1N',
        enabledFor: [3,12,24,48]
      },        
      {
        name: 'V1 L2-N',        
        value: 'Vin1L2N',
        enabledFor: [3,12,24,48]
        
      },
      {
        name: 'V1 L3-N',        
        value: 'Vin1L3N',
        enabledFor: [3,12,24,48]
      },  
      {
        name: 'V2 L1-N',        
        value: 'Vin2L1N',
        enabledFor: [24,48]
      },        
      {
        name: 'V2 L2-N',        
        value: 'Vin2L2N',
        enabledFor: [24,48]
      },
      {
        name: 'V2 L3-N',        
        value: 'Vin2L3N',
        enabledFor: [24,48]
      },
    ]
  },
  {
    name: 'A',
    displayname:'Current',
    description: 'Current', 
    by:'Ch',
    type:'instantaneous',
    uom:'Amps',
    disabled:true,
    elementOptions: 
	[
      {
        name: 'Virtual Meter 1',        
        value: '1'
      },
      {
          name: 'Virtual Meter 2',  
          value: '2'         
      },
      {
          name: 'Virtual Meter 3',    
          value: '3'     
      },
      {
          name: 'Virtual Meter 4',  
          value: '4'       
      },
      {
        name: 'Virtual Meter 5',  
        value: '5'       
      },
      {
        name: 'Virtual Meter 6',  
        value: '6'       
      },
      {
        name: 'Virtual Meter 7',  
        value: '7'       
      },
      {
        name: 'Virtual Meter 8',  
        value: '8'       
      },
      {
        name: 'Virtual Meter 9',  
        value: '9'       
      },
      {
        name: 'Virtual Meter 10',  
        value: '10'       
      },
      {
        name: 'Virtual Meter 11',  
        value: '11'       
      },
      {
        name: 'Virtual Meter 12',  
        value: '12'       
      },
      {
        name: 'Virtual Meter 13',  
        value: '13'       
      },
      {
        name: 'Virtual Meter 14',  
        value: '14'       
      },
      {
        name: 'Virtual Meter 15',  
        value: '15'       
      },
      {
        name: 'Virtual Meter 16',  
        value: '16'       
      },
	  {
        name: 'Virtual Meter 17',  
        value: '17'       
      },
	  {
        name: 'Virtual Meter 18',  
        value: '18'       
      },
	  {
        name: 'Virtual Meter 19',  
        value: '19'       
      },
	  {
        name: 'Virtual Meter 20',  
        value: '20'       
      },
	  {
        name: 'Virtual Meter 21',  
        value: '21'       
      },
	  {
        name: 'Virtual Meter 22',  
        value: '22'       
      },
	  {
        name: 'Virtual Meter 23',  
        value: '23'       
      },
	  {
        name: 'Virtual Meter 24',  
        value: '24'       
      },
	  {
        name: 'Virtual Meter 25',  
        value: '25'       
      },
	  {
        name: 'Virtual Meter 26',  
        value: '26'       
      },
	  {
        name: 'Virtual Meter 27',  
        value: '27'       
      },
	  {
        name: 'Virtual Meter 28',  
        value: '28'       
      },
	  {
        name: 'Virtual Meter 29',  
        value: '29'       
      },
	  {
        name: 'Virtual Meter 30',  
        value: '30'       
      },
	  {
        name: 'Virtual Meter 31',  
        value: '31'       
      },
	  {
        name: 'Virtual Meter 32',  
        value: '32'       
      },
	  {
        name: 'Virtual Meter 33',  
        value: '33'       
      },
	  {
        name: 'Virtual Meter 34',  
        value: '34'       
      },
	  {
        name: 'Virtual Meter 35',  
        value: '35'       
      },
	  {
        name: 'Virtual Meter 36',  
        value: '36'       
      },
	  {
        name: 'Virtual Meter 37',  
        value: '37'       
      },
	  {
        name: 'Virtual Meter 38',  
        value: '38'       
      },
	  {
        name: 'Virtual Meter 39',  
        value: '39'       
      },
	  {
        name: 'Virtual Meter 40',  
        value: '40'       
      },
	  {
        name: 'Virtual Meter 41',  
        value: '41'       
      },
	  {
        name: 'Virtual Meter 42',  
        value: '42'       
      },
	  {
        name: 'Virtual Meter 43',  
        value: '43'       
      },
	  {
        name: 'Virtual Meter 44',  
        value: '44'       
      },
	  {
        name: 'Virtual Meter 45',  
        value: '45'       
      },
	  {
        name: 'Virtual Meter 46',  
        value: '46'       
      },
	  {
        name: 'Virtual Meter 47',  
        value: '47'       
      },
	  {
        name: 'Virtual Meter 48',  
        value: '48'       
      },
    ],
	channelOptions: [
      {
        name: 'Ch 1',        
        value: '1'
      },
      {
        name: 'Ch 2',        
        value: '2'
      },
      {
        name: 'Ch 3',        
        value: '3'
      },

    ],otherOptions:[]

  },
  {
    name: 'kVAHNet',
    displayname:'kVAh Net',
    description: 'kVAh Net', 
    by:'Elm',
    type:'accumulator',
    uom:'kVAh',
    disabled:true,
    elementOptions: 
	[
      {
        name: 'Virtual Meter 1',        
        value: '1'
      },
      {
          name: 'Virtual Meter 2',  
          value: '2'         
      },
      {
          name: 'Virtual Meter 3',    
          value: '3'     
      },
      {
          name: 'Virtual Meter 4',  
          value: '4'       
      },
      {
        name: 'Virtual Meter 5',  
        value: '5'       
      },
      {
        name: 'Virtual Meter 6',  
        value: '6'       
      },
      {
        name: 'Virtual Meter 7',  
        value: '7'       
      },
      {
        name: 'Virtual Meter 8',  
        value: '8'       
      },
      {
        name: 'Virtual Meter 9',  
        value: '9'       
      },
      {
        name: 'Virtual Meter 10',  
        value: '10'       
      },
      {
        name: 'Virtual Meter 11',  
        value: '11'       
      },
      {
        name: 'Virtual Meter 12',  
        value: '12'       
      },
      {
        name: 'Virtual Meter 13',  
        value: '13'       
      },
      {
        name: 'Virtual Meter 14',  
        value: '14'       
      },
      {
        name: 'Virtual Meter 15',  
        value: '15'       
      },
      {
        name: 'Virtual Meter 16',  
        value: '16'       
      },
	  {
        name: 'Virtual Meter 17',  
        value: '17'       
      },
	  {
        name: 'Virtual Meter 18',  
        value: '18'       
      },
	  {
        name: 'Virtual Meter 19',  
        value: '19'       
      },
	  {
        name: 'Virtual Meter 20',  
        value: '20'       
      },
	  {
        name: 'Virtual Meter 21',  
        value: '21'       
      },
	  {
        name: 'Virtual Meter 22',  
        value: '22'       
      },
	  {
        name: 'Virtual Meter 23',  
        value: '23'       
      },
	  {
        name: 'Virtual Meter 24',  
        value: '24'       
      },
	  {
        name: 'Virtual Meter 25',  
        value: '25'       
      },
	  {
        name: 'Virtual Meter 26',  
        value: '26'       
      },
	  {
        name: 'Virtual Meter 27',  
        value: '27'       
      },
	  {
        name: 'Virtual Meter 28',  
        value: '28'       
      },
	  {
        name: 'Virtual Meter 29',  
        value: '29'       
      },
	  {
        name: 'Virtual Meter 30',  
        value: '30'       
      },
	  {
        name: 'Virtual Meter 31',  
        value: '31'       
      },
	  {
        name: 'Virtual Meter 32',  
        value: '32'       
      },
	  {
        name: 'Virtual Meter 33',  
        value: '33'       
      },
	  {
        name: 'Virtual Meter 34',  
        value: '34'       
      },
	  {
        name: 'Virtual Meter 35',  
        value: '35'       
      },
	  {
        name: 'Virtual Meter 36',  
        value: '36'       
      },
	  {
        name: 'Virtual Meter 37',  
        value: '37'       
      },
	  {
        name: 'Virtual Meter 38',  
        value: '38'       
      },
	  {
        name: 'Virtual Meter 39',  
        value: '39'       
      },
	  {
        name: 'Virtual Meter 40',  
        value: '40'       
      },
	  {
        name: 'Virtual Meter 41',  
        value: '41'       
      },
	  {
        name: 'Virtual Meter 42',  
        value: '42'       
      },
	  {
        name: 'Virtual Meter 43',  
        value: '43'       
      },
	  {
        name: 'Virtual Meter 44',  
        value: '44'       
      },
	  {
        name: 'Virtual Meter 45',  
        value: '45'       
      },
	  {
        name: 'Virtual Meter 46',  
        value: '46'       
      },
	  {
        name: 'Virtual Meter 47',  
        value: '47'       
      },
	  {
        name: 'Virtual Meter 48',  
        value: '48'       
      },
    ],
	channelOptions: [],otherOptions:[]   
  },
  {
    name: 'kVARHNet',
    displayname:'kVARh Net',
    description: 'kVAR Hour Net',
    by:'Elm', 
    type:'accumulator',
    uom:'kVARh',
    disabled:true,
    elementOptions: 
	[
      {
        name: 'Virtual Meter 1',        
        value: '1'
      },
      {
          name: 'Virtual Meter 2',  
          value: '2'         
      },
      {
          name: 'Virtual Meter 3',    
          value: '3'     
      },
      {
          name: 'Virtual Meter 4',  
          value: '4'       
      },
      {
        name: 'Virtual Meter 5',  
        value: '5'       
      },
      {
        name: 'Virtual Meter 6',  
        value: '6'       
      },
      {
        name: 'Virtual Meter 7',  
        value: '7'       
      },
      {
        name: 'Virtual Meter 8',  
        value: '8'       
      },
      {
        name: 'Virtual Meter 9',  
        value: '9'       
      },
      {
        name: 'Virtual Meter 10',  
        value: '10'       
      },
      {
        name: 'Virtual Meter 11',  
        value: '11'       
      },
      {
        name: 'Virtual Meter 12',  
        value: '12'       
      },
      {
        name: 'Virtual Meter 13',  
        value: '13'       
      },
      {
        name: 'Virtual Meter 14',  
        value: '14'       
      },
      {
        name: 'Virtual Meter 15',  
        value: '15'       
      },
      {
        name: 'Virtual Meter 16',  
        value: '16'       
      },
	  {
        name: 'Virtual Meter 17',  
        value: '17'       
      },
	  {
        name: 'Virtual Meter 18',  
        value: '18'       
      },
	  {
        name: 'Virtual Meter 19',  
        value: '19'       
      },
	  {
        name: 'Virtual Meter 20',  
        value: '20'       
      },
	  {
        name: 'Virtual Meter 21',  
        value: '21'       
      },
	  {
        name: 'Virtual Meter 22',  
        value: '22'       
      },
	  {
        name: 'Virtual Meter 23',  
        value: '23'       
      },
	  {
        name: 'Virtual Meter 24',  
        value: '24'       
      },
	  {
        name: 'Virtual Meter 25',  
        value: '25'       
      },
	  {
        name: 'Virtual Meter 26',  
        value: '26'       
      },
	  {
        name: 'Virtual Meter 27',  
        value: '27'       
      },
	  {
        name: 'Virtual Meter 28',  
        value: '28'       
      },
	  {
        name: 'Virtual Meter 29',  
        value: '29'       
      },
	  {
        name: 'Virtual Meter 30',  
        value: '30'       
      },
	  {
        name: 'Virtual Meter 31',  
        value: '31'       
      },
	  {
        name: 'Virtual Meter 32',  
        value: '32'       
      },
	  {
        name: 'Virtual Meter 33',  
        value: '33'       
      },
	  {
        name: 'Virtual Meter 34',  
        value: '34'       
      },
	  {
        name: 'Virtual Meter 35',  
        value: '35'       
      },
	  {
        name: 'Virtual Meter 36',  
        value: '36'       
      },
	  {
        name: 'Virtual Meter 37',  
        value: '37'       
      },
	  {
        name: 'Virtual Meter 38',  
        value: '38'       
      },
	  {
        name: 'Virtual Meter 39',  
        value: '39'       
      },
	  {
        name: 'Virtual Meter 40',  
        value: '40'       
      },
	  {
        name: 'Virtual Meter 41',  
        value: '41'       
      },
	  {
        name: 'Virtual Meter 42',  
        value: '42'       
      },
	  {
        name: 'Virtual Meter 43',  
        value: '43'       
      },
	  {
        name: 'Virtual Meter 44',  
        value: '44'       
      },
	  {
        name: 'Virtual Meter 45',  
        value: '45'       
      },
	  {
        name: 'Virtual Meter 46',  
        value: '46'       
      },
	  {
        name: 'Virtual Meter 47',  
        value: '47'       
      },
	  {
        name: 'Virtual Meter 48',  
        value: '48'       
      },
    ],
	channelOptions: [],otherOptions:[]    
  },
  {
    name: 'kWHNet',
    displayname:'kWh',
    description: 'Watt-Hour',  
    by:'Elm',
    type:'accumulator',
    uom:'kWh',
    disabled:true,
    elementOptions: 
	[
      {
        name: 'Virtual Meter 1',        
        value: '1'
      },
      {
          name: 'Virtual Meter 2',  
          value: '2'         
      },
      {
          name: 'Virtual Meter 3',    
          value: '3'     
      },
      {
          name: 'Virtual Meter 4',  
          value: '4'       
      },
      {
        name: 'Virtual Meter 5',  
        value: '5'       
      },
      {
        name: 'Virtual Meter 6',  
        value: '6'       
      },
      {
        name: 'Virtual Meter 7',  
        value: '7'       
      },
      {
        name: 'Virtual Meter 8',  
        value: '8'       
      },
      {
        name: 'Virtual Meter 9',  
        value: '9'       
      },
      {
        name: 'Virtual Meter 10',  
        value: '10'       
      },
      {
        name: 'Virtual Meter 11',  
        value: '11'       
      },
      {
        name: 'Virtual Meter 12',  
        value: '12'       
      },
      {
        name: 'Virtual Meter 13',  
        value: '13'       
      },
      {
        name: 'Virtual Meter 14',  
        value: '14'       
      },
      {
        name: 'Virtual Meter 15',  
        value: '15'       
      },
      {
        name: 'Virtual Meter 16',  
        value: '16'       
      },
	  {
        name: 'Virtual Meter 17',  
        value: '17'       
      },
	  {
        name: 'Virtual Meter 18',  
        value: '18'       
      },
	  {
        name: 'Virtual Meter 19',  
        value: '19'       
      },
	  {
        name: 'Virtual Meter 20',  
        value: '20'       
      },
	  {
        name: 'Virtual Meter 21',  
        value: '21'       
      },
	  {
        name: 'Virtual Meter 22',  
        value: '22'       
      },
	  {
        name: 'Virtual Meter 23',  
        value: '23'       
      },
	  {
        name: 'Virtual Meter 24',  
        value: '24'       
      },
	  {
        name: 'Virtual Meter 25',  
        value: '25'       
      },
	  {
        name: 'Virtual Meter 26',  
        value: '26'       
      },
	  {
        name: 'Virtual Meter 27',  
        value: '27'       
      },
	  {
        name: 'Virtual Meter 28',  
        value: '28'       
      },
	  {
        name: 'Virtual Meter 29',  
        value: '29'       
      },
	  {
        name: 'Virtual Meter 30',  
        value: '30'       
      },
	  {
        name: 'Virtual Meter 31',  
        value: '31'       
      },
	  {
        name: 'Virtual Meter 32',  
        value: '32'       
      },
	  {
        name: 'Virtual Meter 33',  
        value: '33'       
      },
	  {
        name: 'Virtual Meter 34',  
        value: '34'       
      },
	  {
        name: 'Virtual Meter 35',  
        value: '35'       
      },
	  {
        name: 'Virtual Meter 36',  
        value: '36'       
      },
	  {
        name: 'Virtual Meter 37',  
        value: '37'       
      },
	  {
        name: 'Virtual Meter 38',  
        value: '38'       
      },
	  {
        name: 'Virtual Meter 39',  
        value: '39'       
      },
	  {
        name: 'Virtual Meter 40',  
        value: '40'       
      },
	  {
        name: 'Virtual Meter 41',  
        value: '41'       
      },
	  {
        name: 'Virtual Meter 42',  
        value: '42'       
      },
	  {
        name: 'Virtual Meter 43',  
        value: '43'       
      },
	  {
        name: 'Virtual Meter 44',  
        value: '44'       
      },
	  {
        name: 'Virtual Meter 45',  
        value: '45'       
      },
	  {
        name: 'Virtual Meter 46',  
        value: '46'       
      },
	  {
        name: 'Virtual Meter 47',  
        value: '47'       
      },
	  {
        name: 'Virtual Meter 48',  
        value: '48'       
      },
    ],
	channelOptions: [],otherOptions:[]   
  },
];

export const meterParameterOptions = [    
  {
    name: 'dPF',
    displayname:'dPF',
    description: 'Displacement Power Factor (Element)',    
    by:'Elm',
    type:'instantaneous',
    disabled:true,
    uom:'dPF',
    elementOptions: 
      [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]
    
  },
  {
    name: 'dPF',
    displayname:'dPF',
    description: 'Displacement Power Factor (Channel)',    
    by:'Ch',
    type:'instantaneous',
    uom:'dPF',
    disabled:true,
    elementOptions: 
      [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      }
      ,
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [
      {
        name: 'Ch 1',        
        value: '1'
      },
      {
        name: 'Ch 2',        
        value: '2'
      },
      {
        name: 'Ch 3',        
        value: '3'
      },

    ],otherOptions:[]
    
  },
  {
    name: 'DemandkW',
    displayname: 'kW Demand Wattage',
    description: 'Demand Wattage', 
    by:'Elm',
    type:'instantaneous',
    uom:'kW',
    disabled:true,
    elementOptions: 
      [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]
  },
  {
    name: 'DemandkWPeak',
    displayname:'kW Demand Max',
    description: 'Maximum Demand Wattage',
    by:'Elm', 
    type:'accumulator',
    uom:'kW',
    disabled:true,
    elementOptions: 
      [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],
    otherOptions:[]
  },
  {
    name: 'V',
    displayname:'Voltage',
    description: 'Volts',
    by:'Ch',
    type:'instantaneous',
    uom:'Volts',
    disabled:true,
    elementOptions: [],
    channelOptions: [],
    otherOptions: [
      {
        name: 'L1-N',        
        value: 'Vin1L1N'
      },        
      {
        name: 'L2-N',        
        value: 'Vin1L2N'
      },
      {
        name: 'L3-N',        
        value: 'Vin1L3N'
      },  
    ]
  },
  {
    name: 'A',
    displayname:'Current',
    description: 'Current', 
    by:'Ch',
    type:'instantaneous',
    uom:'Amps',
    disabled:true,
    elementOptions: [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [
      {
        name: 'Ch 1',        
        value: '1'
      },
      {
        name: 'Ch 2',        
        value: '2'
      },
      {
        name: 'Ch 3',        
        value: '3'
      },

    ],otherOptions:[]

  },
  {
    name: 'kVAHNet',
    displayname:'kVAh Net',
    description: 'kVAh Net', 
    by:'Elm',
    type:'accumulator',
    uom:'kVAh',
    disabled:true,
    elementOptions: [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]   
  },
  {
    name: 'kVARHNet',
    displayname:'kVARh Net',
    description: 'kVAR Hour Net',
    by:'Elm', 
    type:'accumulator',
    uom:'kVARh',
    disabled:true,
    elementOptions: [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]    
  },
  {
    name: 'kWHNet',
    displayname:'kWh',
    description: 'Watt-Hour',  
    by:'Elm',
    type:'accumulator',
    uom:'kWh',
    disabled:true,
    elementOptions: [
      {
        name: 'Element A',        
        value: 'A'
      },
      {
          name: 'Element B',  
          value: 'B'         
      },
      {
          name: 'Element C',    
          value: 'C'     
      },
      {
          name: 'Element D',  
          value: 'D'       
      },
      {
        name: 'Element E',  
        value: 'E'       
      },
      {
        name: 'Element F',  
        value: 'F'       
      },
      {
        name: 'Element G',  
        value: 'G'       
      },
      {
        name: 'Element H',  
        value: 'H'       
      },
      {
        name: 'Element I',  
        value: 'I'       
      },
      {
        name: 'Element J',  
        value: 'J'       
      },
      {
        name: 'Element K',  
        value: 'K'       
      },
      {
        name: 'Element L',  
        value: 'L'       
      },
      {
        name: 'Element M',  
        value: 'M'       
      },
      {
        name: 'Element N',  
        value: 'N'       
      },
      {
        name: 'Element O',  
        value: 'O'       
      },
      {
        name: 'Element P',  
        value: 'P'       
      }
    ],
    channelOptions: [],otherOptions:[]   
  },
];


 export const dataSetTypes = [{
    value:'graph',
    name:'Graphed Values',
    icon: `<img src='/assets/graph-svgrepo-com.svg' alt=graph />` 
  
  },{
    value:'value',
    name:'Accumulated Value',
    icon:`<img src='/assets/number-chart.webp' alt='number-graph' />` 
  }];


export function getParamColor(i){
  var items = [
    '#FFA800',
    '#199504',
    '#AE0E0E',
    '#326CAF',
    '#881484',
    '#190ae7',
    '#079e62',
    '#d0ec4a',
    '#fd6a00',
    '#8f0b0b',
  ]
  return items[i];

}